/* eslint-disable no-await-in-loop */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unsafe-optional-chaining */
import React, { memo, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Col, message, Row, Spin, Switch } from 'antd';
import { List, Scheduler } from 'devextreme-react';
import moment from 'moment';
import { useParams } from 'react-router-dom';

import { CalendarOutlined, LoadingOutlined, UnorderedListOutlined } from '@ant-design/icons';

import Utils from '../../Assets/Scripts/Utils';
import CustomDropdown from '../../Components/CustomDropdown/CustomDropdown';
import ModalIntercurrence from '../../Components/ModalIntercurrence/ModalIntercurrence';
import ModalTrainingConclusion from '../../Components/ModalTrainingConclusion/ModalTrainingConclusion';
import ReasonModal from '../../Components/ReasonModal/ReasonModal';
import { readPortalResource } from '../../Components/ResourceFieldLayout/shouldRenderTaskField';
import Appointment from '../../Components/Schedule/Appointment';
import DataCell from '../../Components/Schedule/DataCell';
import DataCellMonth from '../../Components/Schedule/DataCellMonth';
import DateCell from '../../Components/Schedule/DateCell';
import ListItem from '../../Components/Schedule/ListItem';
import ScheduleUtils from '../../Components/Schedule/ScheduleUtils';
import TaskCommentFunctions from '../../Components/Schedule/TaskCommentFunctions';
import { api } from '../../Services/axiosService';
import { loadAgendaFieldLayout } from '../Role/FieldCustomization/API/FieldCustomizationApi';
import TaskDrawer from '../ScheduleConecta/Components/TaskDrawer';

import './ScheduleInstructor.scss';
import '../../Assets/Style/ScheduleOperator.scss';
import '../../Components/Schedule/ListItem.scss';
import '../../Components/Schedule/TasksList.scss';

let taskAcceptanceDeadline = 0;

let finishMargin = null;
let timeout = null;
let currentListItem = null;

const views = [
  {
    name: 'Dia',
    type: 'day',
    cellDuration: 60,
  },
  {
    name: 'Semana',
    type: 'week',
    cellDuration: 60,
  },
  {
    name: 'Mês',
    type: 'month',
  },
];

function ScheduleInstructorComponent() {
  const { id: idUserURL = 0, taskId, action, scheduleType: urlScheduleType } = useParams();

  const schedulerRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [loadingSchedule, setLoadingSchedule] = useState(false);
  const [currentView, setCurrentView] = useState('week');
  const [currentDate, setCurrentDate] = useState(new Date());
  const [appointments, setAppointments] = useState([]);
  const [instructor, setInstructor] = useState();
  const [blockedDates, setBlockedDates] = useState([]);
  const [fieldsPermissions, setFieldsPermissions] = useState();
  const [agendaResourceId, setAgendaResourceId] = useState();
  const [agendaResourceName, setAgendaResourceName] = useState();
  const [fieldLayout, setFieldLayout] = useState();
  const [roleId, setRoleId] = useState();
  const [changeVisibility, setChangeVisibility] = useState(false);
  const [initialTab, setInitialTab] = useState('communication');
  const [settings, setSettings] = useState();

  // Popups
  const [showModalIntercurrence, setShowModalIntercurrence] = useState(false);
  const [showConclusionModal, setShowConclusionModal] = useState(false);
  const [isReasonModalOpen, setReasonModalOpen] = useState(false);
  const [reasonEvent, setReasonEvent] = useState('');
  const [reasonOnOk, setReasonOnOk] = useState(null);
  const [reasonEventSource, setReasonEventSource] = useState(null);

  // TaskDrawer
  const [isTaskDrawerVisible, setIsTaskDrawerVisible] = useState(false);
  const [currentTask, setCurrentTask] = useState(null);
  const [quoteList, setQuoteList] = useState([]);
  const [isTaskReadOnly, setIsTaskReadOnly] = useState(false);
  const [scheduleType, setScheduleType] = useState(null);

  // Select Options
  const [instructorOptions, setInstructorOptions] = useState([]);
  const [transportOptions, setTransportOptions] = useState([]);
  const [reasonNoBillingOptions, setReasonNoBillingOptions] = useState([]);
  const [invoiceIssuersOptions, setInvoiceIssuersOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [driverOptions, setDriverOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [certificateModelOptions, setCertificateModelOptions] = useState([]);
  const [trainingsOptions, setTrainingsOptions] = useState();
  const [reasonsOptions, setReasonsOptions] = useState();
  const [stages, setStages] = useState();

  useEffect(() => {
    const openTraining = action === 'OpenTraining';
    const openCommunication = action === 'OpenCommunication';

    if (taskId && urlScheduleType && (openTraining || openCommunication)) {
      const formattedScheduleType =
        urlScheduleType.charAt(0).toLowerCase() + urlScheduleType.slice(1);

      setScheduleType(formattedScheduleType);
      setCurrentTask({ id: parseInt(taskId, 10) });

      if (openCommunication) {
        setInitialTab('communication');
      }

      setIsTaskDrawerVisible(true);
    }
  }, [taskId, action, urlScheduleType]);

  const handleTaskUpdated = (updatedTask) => {
    setAppointments((prev) =>
      prev.map((appointment) =>
        appointment.id === updatedTask.id ? { ...appointment, ...updatedTask } : appointment
      )
    );
  };

  const confirmTask = async (task) => {
    setLoadingSchedule(true);
    const localScheduleType = task?.scheduleType || scheduleType;
    const data = JSON.parse(JSON.stringify(task)); // Deep Copy da task
    const confirmStage = stages?.find(({ id }) => id === 3);
    data[localScheduleType].stage = confirmStage;

    await api
      .put('/Task/UpdateTaskStage', data)
      .then(() => {
        message.success('Treinamento Aceito!');
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao Aceitar o Treinamento!');
      });

    const objectIdUser = {
      Id: data[localScheduleType].userId,
    };

    await api
      .put('/Instructor/InstructorTaskCount', objectIdUser)
      .then((res) => res)
      .catch((error) => Utils.logError(error));

    // Adiciona Atividade no Treinamento
    await TaskCommentFunctions.addTaskComment(data, 'TaskAccepted', data.scheduleType, '');

    // Preenche Histórico de Treinamento
    await ScheduleUtils.sendTrainingHistory(
      data.id,
      data.cardTitle,
      confirmStage,
      moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')
    );

    // Envia Notificação para Logística, informando o Aceite do Treinamento
    await ScheduleUtils.sendNotificationToLogistics(data, scheduleType, null, true);

    task[scheduleType].stage = confirmStage; // Altera o valor no objeto original
    handleTaskUpdated(task);
    setLoadingSchedule(false);
  };

  const denyTask = async (task) => {
    const localScheduleType = task?.scheduleType || scheduleType;
    const data = JSON.parse(JSON.stringify(task)); // Deep Copy da task
    const deniedStage = stages?.find(({ id }) => id === 4);

    // Remove vínculo do instrutor conforme o tipo
    data[localScheduleType] = null;
    const pathUpdate = [
      {
        op: 'replace',
        path: localScheduleType === 'mainInstructor' ? '/MainInstructor' : '/AssistantInstructor',
        value: null,
      },
    ];

    const handleDeny = async () => {
      setLoadingSchedule(true);

      await api
        .patch(`/Task/${data.id}`, pathUpdate, {
          headers: { 'Content-Type': 'application/json-patch+json' },
        })
        .catch((error) => {
          Utils.logError(error);
          message.error('Oops. Algo deu errado ao negar o treinamento!');
        });

      await ScheduleUtils.sendTrainingHistory(
        data.id,
        data.cardTitle,
        deniedStage,
        moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')
      );

      setAppointments((prev) =>
        prev
          .filter(
            (appointment) =>
              !(appointment.id === task.id && appointment.scheduleType === localScheduleType)
          )
          .map((appointment, index) => ({ ...appointment, index }))
      );

      setLoadingSchedule(false);
      setIsTaskDrawerVisible(false);
      message.success('Treinamento Negado!');
    };

    setReasonEvent('InstructorTaskDenied');
    setCurrentTask(task);
    setReasonOnOk(() => handleDeny);
    setReasonEventSource(localScheduleType);
    setReasonModalOpen(true);
  };

  const onAppointmentUpdating = (e) => {
    e.cancel = true;
  };

  const onAppointmentDblClick = (e) => {
    e.cancel = true;
    const { appointmentData } = e;

    setScheduleType(appointmentData.scheduleType);
    setCurrentTask(appointmentData);
    setIsTaskDrawerVisible(true);
  };

  const onListItemClick = (e) => {
    const { itemData } = e;

    if (!timeout) {
      timeout = setTimeout(() => {
        timeout = null;
      }, 300);
    } else if (itemData.id === currentListItem) {
      setScheduleType(itemData.scheduleType);
      setCurrentTask(itemData);
      setIsTaskDrawerVisible(true);
    }

    currentListItem = itemData.id;
  };

  const onCurrentViewChange = (value) => {
    localStorage.setItem('conecta__currentView', value);
    setCurrentView(value);
  };

  const onCurrentDateChange = (value) => {
    localStorage.setItem('conecta__currentDate', value);
    setCurrentDate(value);
  };

  const renderDataCell = (itemData) => {
    const CellTemplate = currentView === 'month' ? DataCellMonth : DataCell;

    return (
      <CellTemplate
        itemData={itemData}
        workDays={instructor?.workDays}
        blockedDates={blockedDates}
        appointments={appointments}
      />
    );
  };

  const renderDateCell = (itemData) => (
    <DateCell
      itemData={itemData}
      workDays={instructor?.workDays}
      blockedDates={blockedDates}
      appointments={appointments}
    />
  );

  const appointmentRender = (itemData) => <Appointment itemData={itemData} />;

  const renderItem = (itemData) => (
    <ListItem
      itemData={itemData}
      confirmTask={confirmTask}
      denyTask={denyTask}
      loading={loadingSchedule}
      hasIdUserURL={idUserURL === 0}
    />
  );

  const getInstructor = async () => {
    try {
      setLoading(true);
      const instructorUserId = parseInt(
        JSON.parse(localStorage.getItem('conecta__userData'))?.id,
        10
      );
      const userId = idUserURL > 0 ? idUserURL : instructorUserId;

      const user = await api
        .get(`/User?id=${userId}`)
        .then((res) => res.data)
        .catch((error) => error);

      const instructor = await api
        .get(`/Instructor?id=${user.company.id}`)
        .then((res) => res.data)
        .catch((error) => error);

      const tasksMainInstructor = await api
        .get(
          `/Task?filters[0].Field=MainInstructor.UserId&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${userId}`
        )
        .then((res) => res.data)
        .catch((error) => error);

      const tasksAssistantInstructor = await api
        .get(
          `/Task?filters[0].Field=AssistantInstructor.UserId&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${userId}`
        )
        .then((res) => res.data)
        .catch((error) => error);

      const bookedDays = await api
        .get(
          `/InstructorBooking?filters[0].Field=InstructorUserId&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${userId}`
        )
        .then((res) => res.data)
        .catch((error) => error);

      const bookedDaysMapped = bookedDays.map((task) => ({
        ...task,
        allDay: true,
        startDate: moment(new Date(task.date).setHours(0, 0, 0, 1)),
        endDate: moment(new Date(task.date).setHours(0, 0, 0, 2)),
      }));

      const tasksMainInstructorMapped = tasksMainInstructor.map((task, index) => ({
        ...task,
        text: task.product.name,
        scheduleType: 'mainInstructor',
        index,
      }));

      const tasksAssistantInstructorMapped = tasksAssistantInstructor.map((task, index) => ({
        ...task,
        text: task.product.name,
        scheduleType: 'assistantInstructor',
        index,
      }));

      setInstructor(instructor);
      setAppointments([
        ...tasksMainInstructorMapped,
        ...tasksAssistantInstructorMapped,
        ...bookedDaysMapped,
      ]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao buscar os dados do Instrutor!');
    }
  };

  const getBlockedDays = () =>
    api
      .get(
        `/BlockedDay?filters[0].Field=InstructorId&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${parseInt(
          JSON.parse(localStorage.getItem('conecta__userData'))?.id,
          10
        )}`
      )
      .then((res) => setBlockedDates(res.data))
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Dias Bloqueados!');
      });

  const getTrainings = () =>
    api
      .get('/Trainings')
      .then((res) => setTrainingsOptions(res.data))
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Grupos de Treinamento!');
      });

  const getStages = () =>
    api
      .get(`/Stage`)
      .then((res) => setStages(res.data))
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Estágios!');
      });

  const fetchReasons = async () => {
    const reasons = await api
      .get(
        `/DenyTaskReason?filters[0].Field=Type&filters[0].Condition=IN&filters[0].Value=Scheduling,Logistics,NoBilling,Instructor&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo`
      )
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Motivos!');
      });

    setReasonsOptions(
      reasons?.map(({ id, name, type }) => ({
        label: name,
        value: id,
        type,
      }))
    );

    setReasonNoBillingOptions(
      reasons
        ?.filter(({ type }) => type === 'NoBilling')
        .map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
          type: item.type,
        }))
    );
  };

  const fetchInstructors = async () => {
    try {
      const filter = `/Instructor?filters[0].Field=CompanyType&filters[0].Condition=EQUAL&filters[0].Value=Instrutor&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo`;
      const companyInstructors = await api.get(filter).then((res) => res.data);

      const chunkSize = 30;
      let instructors = [];

      for (let i = 0; i < companyInstructors?.length; i += chunkSize) {
        const chunkInstructors = companyInstructors?.slice(i, i + chunkSize);
        const instructorIds = chunkInstructors.map(({ id }) => id).toString();
        const userFilter = `/User?filters[0].Field=Company.Id&filters[0].Condition=NUMBER.IN&filters[0].Value=${instructorIds}&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo`;

        const chunkInstructorOptions = await api.get(userFilter).then((res) => res.data);
        const mappedInstructors = chunkInstructorOptions.map((item) => {
          const instructorData = companyInstructors.find(({ id }) => id === item.company.id);

          return { ...instructorData, ...item };
        });
        instructors = [...instructors, ...mappedInstructors];
      }

      setInstructorOptions(instructors);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao buscar os Instrutores!');
    }
  };

  const fetchDrivers = async () => {
    try {
      const filter = `/Driver?filters[0].Field=CompanyType&filters[0].Condition=EQUAL&filters[0].Value=Motorista&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo`;
      const companyDrivers = await api.get(filter).then((res) => res.data);

      const chunkSize = 30;
      let drivers = [];

      for (let i = 0; i < companyDrivers?.length; i += chunkSize) {
        const chunkDrivers = companyDrivers?.slice(i, i + chunkSize);
        const driverIds = chunkDrivers.map(({ id }) => id).toString();
        const userFilter = `/User?filters[0].Field=Company.Id&filters[0].Condition=NUMBER.IN&filters[0].Value=${driverIds}&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo`;

        const chunkDriverOptions = await api.get(userFilter).then((res) => res.data);

        // Mapeamento dos motoristas para garantir campos obrigatórios
        const mappedDrivers = chunkDriverOptions.map((driver) => ({
          ...driver,
          userId: driver.id,
          userName: driver.name,
        }));

        drivers = [...drivers, ...mappedDrivers];
      }

      setDriverOptions(drivers);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao buscar os Motoristas!');
    }
  };

  const fetchTransportCompanies = async () => {
    try {
      const response = await api.get(
        '/Transport?filters[0].Field=CompanyType&filters[0].Condition=IN&filters[0].Value=Transporte&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo'
      );

      const responseMapped = response.data.map((tc) => ({
        ...tc,
        value: tc.id,
        label: tc.commercialName || tc.name,
      }));
      setTransportOptions(responseMapped);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar buscar as Empresas de Transporte!');
    }
  };

  const getProducts = () =>
    api
      .get('/Product')
      .then((res) => {
        const mappedProducts = res.data.map((product) => ({
          ...product,
          label: product.name,
          value: product.id,
        }));
        setProductOptions(mappedProducts);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Produtos!');
      });

  const fetchSettings = () =>
    api
      .get(`/Settings?id=1`)
      .then(async (res) => {
        const decryptedResponse = Utils.decryptSettings(res.data);

        finishMargin = decryptedResponse.conclusionMargin;
        taskAcceptanceDeadline = decryptedResponse.taskAcceptanceDeadline;
        setCertificateModelOptions(decryptedResponse.certificateModelList ?? []);
        setSettings(decryptedResponse);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar as configurações!');
      });

  const getInvoiceIssuers = () =>
    api
      .get('/InvoiceIssuer')
      .then((res) => {
        const mappedIssuers = res.data.map((issuer) => ({
          ...issuer,
          label: issuer.name,
          value: issuer.id,
        }));
        setInvoiceIssuersOptions(mappedIssuers);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Emissores de Nota!');
      });

  const fetchVehicles = () =>
    api
      .get(
        '/Vehicle?filters[0].Field=Status&filters[0].Condition=DIFFERENT&filters[0].Value=Inativo'
      )
      .then((res) => {
        const mappedOptions = res.data.map((item) => ({
          ...item,
          value: item.id,
          label: `${item.licensePlate} - ${item.type.name} (${item.capacity} pessoas)`,
        }));

        setVehicleOptions(mappedOptions);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar Veículos!');
      });

  useLayoutEffect(() => {
    const permissions = {};
    JSON.parse(localStorage.getItem('conecta__permissions'))?.resources.forEach(
      ({ name, fields }) => {
        if (name === 'ScheduleInstructor') {
          fields.forEach(({ name, access, isRequired, isADM }) => {
            permissions[name] = { access, isRequired, isADM };
          });
        }
      }
    );

    setFieldsPermissions(permissions);
    const portalResource = readPortalResource('ScheduleInstructor');
    setAgendaResourceId(portalResource.resourceId);
    setAgendaResourceName(portalResource.resourceName);
    setRoleId(JSON.parse(localStorage.getItem('conecta__permissions'))?.id);
    loadAgendaFieldLayout(portalResource.resourceId).then(setFieldLayout);
    getInstructor();
    getBlockedDays();
    getTrainings();
    getStages();
    fetchReasons();
    fetchInstructors();
    fetchTransportCompanies();
    getProducts();
    fetchSettings();
    getInvoiceIssuers();
    fetchVehicles();
    fetchDrivers();
  }, []);

  if (loading) {
    return (
      <Row gutter={[24]}>
        <Col
          span={24}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '72vh',
          }}
        >
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 56,
                  textAlign: 'center',
                }}
                spin
              />
            }
          />
        </Col>
      </Row>
    );
  }

  if (!loading) {
    return (
      <Row gutter={[12]}>
        <Col span={24}>
          <div className="changeVisibility">
            <Switch
              style={{
                marginBottom: 10,
              }}
              checkedChildren={<CalendarOutlined />}
              unCheckedChildren={<UnorderedListOutlined />}
              defaultChecked
              onClick={() => {
                setChangeVisibility(!changeVisibility);
              }}
            />
          </div>

          <List
            id="tasks-list"
            style={{ marginTop: 35 }}
            visible={changeVisibility}
            dataSource={appointments.filter(({ allDay }) => !allDay)}
            height="calc(100vh - 90px)"
            searchExpr={[
              'text',
              'classId',
              'quoteTitle',
              'stage.mainInstructor.name',
              'stage.assistantInstructor.name',
              'startDate',
            ]}
            searchEnabled={true}
            itemRender={renderItem}
            onItemClick={onListItemClick}
          />

          {idUserURL === 0 && (
            <CustomDropdown
              type="Instructor"
              sourceId={parseInt(JSON.parse(localStorage.getItem('conecta__userData'))?.id, 10)}
              dataSource={appointments}
              updateBlockedDays={getBlockedDays}
              workDays={instructor?.workDays}
              breakTime={{
                breakStart: instructor?.breakStart,
                breakFinish: instructor?.breakFinish,
              }}
              blockedDates={blockedDates}
              visible={changeVisibility}
            />
          )}

          <Scheduler
            style={
              !changeVisibility
                ? null
                : {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: 0,
                    width: 0,
                    visibility: 'hidden',
                  }
            }
            ref={schedulerRef}
            disabled={loadingSchedule}
            id="scheduleOperator"
            views={views}
            dataSource={appointments}
            defaultCurrentView={
              localStorage.getItem('conecta__currentView')
                ? localStorage.getItem('conecta__currentView')
                : currentView
            }
            defaultCurrentDate={
              localStorage.getItem('conecta__currentDate')
                ? new Date(localStorage.getItem('conecta__currentDate'))
                : currentDate
            }
            startDayHour={8}
            endDayHour={18}
            showAllDayPanel={true}
            allDayPanelMode="allDay"
            firstDayOfWeek={1}
            maxAppointmentsPerCell={1}
            height="calc(100vh - 98px)"
            dataCellRender={renderDataCell}
            dateCellRender={renderDateCell}
            onCurrentViewChange={onCurrentViewChange}
            onCurrentDateChange={onCurrentDateChange}
            onAppointmentDblClick={onAppointmentDblClick}
            onAppointmentUpdating={onAppointmentUpdating}
            appointmentComponent={appointmentRender}
            crossScrollingEnabled
            showCurrentTimeIndicator={false}
            timeCellRender={() => <div />}
            editing={{
              allowResizing: false,
              allowDeleting: false,
              allowDragging: false,
            }}
            onCellClick={(e) => {
              e.cancel = true;
            }}
            useDropDownViewSwitcher
          />
        </Col>

        {showModalIntercurrence && (
          <ModalIntercurrence
            currentOpenTask={currentTask}
            eventSource={scheduleType}
            setShowModalIntercurrence={setShowModalIntercurrence}
          />
        )}

        {showConclusionModal && (
          <ModalTrainingConclusion
            currentOpenTask={currentTask}
            loading={loadingSchedule}
            setShowConclusionModal={setShowConclusionModal}
            eventSource={scheduleType}
            reasonsOptions={reasonsOptions}
            finishMargin={finishMargin}
            stages={stages}
            onTaskUpdated={handleTaskUpdated}
            setIsTaskDrawerVisible={setIsTaskDrawerVisible}
          />
        )}

        {isReasonModalOpen && (
          <ReasonModal
            setModalOpen={setReasonModalOpen}
            reasonsOptions={reasonsOptions}
            currentOpenTask={currentTask}
            event={reasonEvent}
            eventSource={reasonEventSource || scheduleType}
            onOk={reasonOnOk}
          />
        )}

        {isTaskDrawerVisible && (
          <TaskDrawer
            taskId={currentTask?.id}
            fieldsPermissions={fieldsPermissions}
            stages={stages}
            instructorOptions={instructorOptions}
            trainingsOptions={trainingsOptions}
            transportOptions={transportOptions}
            reasonNoBillingOptions={reasonNoBillingOptions}
            invoiceIssuersOptions={invoiceIssuersOptions}
            vehicleOptions={vehicleOptions}
            driverOptions={driverOptions}
            productOptions={productOptions}
            certificateModelOptions={certificateModelOptions}
            setIsTaskDrawerVisible={setIsTaskDrawerVisible}
            taskAcceptanceDeadline={taskAcceptanceDeadline}
            setAppointments={setAppointments}
            setQuoteList={setQuoteList}
            appointments={appointments}
            quoteList={quoteList}
            isTaskReadOnly={isTaskReadOnly}
            setIsTaskReadOnly={setIsTaskReadOnly}
            scheduleType={scheduleType}
            confirmTask={confirmTask}
            denyTask={denyTask}
            setShowConclusionModal={setShowConclusionModal}
            setShowModalIntercurrence={setShowModalIntercurrence}
            setCurrentTask={setCurrentTask}
            initialTab={initialTab}
            settings={settings}
            resourceId={agendaResourceId}
            resourceName={agendaResourceName}
            fieldLayout={fieldLayout}
            roleId={roleId}
          />
        )}
      </Row>
    );
  }
}

const ScheduleInstructor = memo(ScheduleInstructorComponent);
export default ScheduleInstructor;
